// 全局水印
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'dva'
import { modelUtils } from '@/utils'
import { framework_tool, utils_tool } from '@/tool'
import { request } from '@/utils/commonUtils';
import { watermarkCfg } from '@/utils/watermarkAbout'
import WizWatermark from 'wiz-watermark'

const { WizContainer } = framework_tool
const { Storage } = utils_tool

// 根据路由pathname进行全局水印的展示和隐藏
const HIDEPATH = [
    'watermark'
]

/**
 * 视频水印需要单独添加
 * cfg wizWatermark水印组件的配置参数
 * platform  请求配置参数 管理端,学员端,小程序端,课程学习,直播页面
 * settingObj  参考 storage-user, 如果设置此参数,会将该内容设置为水印渲染时指向的object
 */

class WizWatermarkCmp extends WizContainer {
    componentName = 'WizWatermarkCmp'

    constructor(props) {
        super(props)
        this.state = {
            watermarkInfo: [],
            watermarkShow: true
        }
    }

    componentDidMount() {
        let timer = null
        let { platform = 0 } = this.props
        timer = setInterval(() => {
            let { userType = '', fullName = '' } = Storage.getStorage('user');
            if (fullName) {
                this.getWatermarkList({
                    userType,
                    platform,
                    state: 1
                })
                clearInterval(timer)
            }
        }, 1000)
    }

    componentWillMount() {

    }

    componentWillReceiveProps(nextProps) {
        let pname = nextProps.location.pathname
        let slicePath = pname.slice(1)
        // console.log(HIDEPATH.includes(slicePath))
        this.setState({
            watermarkShow: !HIDEPATH.includes(slicePath)
        })
    }

    propsAndStateOnChange = {
        list: this._getWatermarkList.bind(this),
    };

    getWatermarkList = (params = {}) => request.call(this, 'wizWatermarkInfo/list', { ...params });


    _getWatermarkList(nextProps, nextState) {
        const { list } = nextProps;
        let { success, msg, data } = list
        if (success && data) {
            nextState.watermarkInfo = data
            return true;
        }
        wizNotice.error(msg || '获取水印配置失败')
        return false;
    }

    _renderWatermark() {
        let { watermarkInfo = [], watermarkShow } = this.state
        let { cfg = {} } = this.props
        let mapCfg = watermarkInfo.map((item, i) => {
            return watermarkCfg(item)
        })
        return watermarkShow ? mapCfg.map((item, i) => {
            return (
                <WizWatermark {...item} {...cfg} key={i} />
            )
        }) : null
    }

    _render() {
        let { watermarkInfo } = this.state
        return (
            watermarkInfo.length ? this._renderWatermark() : null
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    let { wizWatermarkInfo } = state
    const list = modelUtils.getModelEntity(wizWatermarkInfo, 'wizWatermarkInfo@list')
    return {
        list
    }
}

export default connect(mapStateToProps)(WizWatermarkCmp)